module.exports = require('react-dd');



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/dd.js
// module id = 3
// module chunks = 0 1 2 3 4